import { arrayTrieEncode, trieCreate, trieSet } from '@smikhalevski/trie';
import rawSortedTermArray from './terms_array_full.json' with { type: "json" };
import { Module } from '@nu-art/ts-common';
import { apiWithBody, ModuleFE_XHR } from '@nu-art/thunderstorm-frontend';
import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { ApiDef_Dictionary } from '@app/hcs-shared/dictionary/index';
export class ModuleFE_Dictionary_Class extends Module {
    vv1;
    trie;
    arrayTrie;
    // public spellchecker!: typeof Spellchecker;
    constructor() {
        super();
        this.vv1 = {
            getDictionaryFiles: apiWithBody(ApiDef_Dictionary.vv1.getDictionaryFiles),
        };
    }
    init() {
        this.initializeTrie();
        // setTimeout(async () => {
        // 	await this.initializeSpellChecker();
        // });
    }
    initializeTrie() {
        const sortedTermArray = rawSortedTermArray;
        this.trie = trieCreate();
        sortedTermArray.forEach(term => trieSet(this.trie, term, term));
        this.arrayTrie = arrayTrieEncode(this.trie);
    }
    // private async initializeSpellChecker() {
    // 	this.spellchecker = new Spellchecker();
    //
    // 	// const response = await this.vv1.getDictionaryFiles({}).executeSync();
    // 	// const affFile = await this.getFileFromUrl(response.files[0].affSignedUrl);
    // 	// const dicFile = await this.getFileFromUrl(response.files[0].dicSignedUrl);
    //
    // 	const encoder = new TextEncoder();
    // 	const DICT = this.spellchecker.parse({
    // 		aff: Buffer.from(encoder.encode(affFile.content)),
    // 		dic: Buffer.from(encoder.encode(dicFile.content))
    // 	});
    //
    //
    // 	this.spellchecker.use(DICT);
    // }
    async getFileFromUrl(url) {
        return await ModuleFE_XHR.createRequest({ fullUrl: url, method: HttpMethod.GET, path: '' }).executeSync();
    }
}
export const ModuleFE_Dictionary = new ModuleFE_Dictionary_Class();
//# sourceMappingURL=ModuleFE_Dictionary.js.map